<template>
  <SeatingPlan
    :number-of-seats="63"
    :double-placeholder-before="[31]"
    :reorder-seats="[59, 60, 61, 62, 63]"
  />
</template>

<script lang="ts" setup>
import SeatingPlan from './SeatingPlan.vue';
</script>
